module.exports = __webpack_public_path__ + "img/levno_logo_blue_no_tm.83a7d534.svg";